// extracted by mini-css-extract-plugin
module.exports = {"containerQrCode":"styles_containerQrCode__1TdNQ","containerButtonsModalQrCode":"styles_containerButtonsModalQrCode__2LH8c"};